import { apiClient } from '@devd-client/api';
import { getToken, getOrgId } from '@devd-client/devd/auth';

//   Todo: Type of params
export const uploadFile = (params: any): Promise<any> =>
  apiClient(`/v1/upload`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params),
  });

export const getTeamMemberToSelect = (team: string): Promise<any> =>
  apiClient(`/v1/employee/org/${getOrgId()}/team?team=${team}`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const getNonTeamMember = (role: string, team: string): Promise<any> =>
  apiClient(
    `/v1/employee/org/${getOrgId()}/team-not?role=${role}&teamNot=${team}`,
    {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );

export const getTeamMembers = (team: string): Promise<any> =>
  apiClient(`/v1/team/members/org/${getOrgId()}/team/${team}`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const updateTeamMemberRole = ({
  team,
  role,
  email,
}: {
  team: string;
  role: string;
  email: string;
}): Promise<any> => {
  return apiClient(`/v1/team/org/${getOrgId()}/teamName/${team}`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      email,
      role,
    }),
  });
};

export const addMembers = (params: any): Promise<any> =>
  apiClient(`/v1/team/members/org/${getOrgId()}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params),
  });

export const deleteMembers = (params: any): Promise<any> =>
  apiClient(
    `/v1/team/members/org/${getOrgId()}?teamName=${
      params.team
    }&email=${encodeURIComponent(params.email)}`,
    {
      method: 'DELETE',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );

export const getTeams = (team: string): Promise<any> =>
  apiClient(
    `/v2/team/${getOrgId()}${team ? `?team=${encodeURIComponent(team)}` : ''}`,
    {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );

export const getParentTeams = (teamNot: string): Promise<any> =>
  apiClient(`/v2/team/${getOrgId()}/lite?type=parent&teamNot=${teamNot}`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const getDataByTeams = (team: string): Promise<any> =>
  apiClient(`/v1/team/${getOrgId()}/${team}`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const getAllGitRepos = (): Promise<any> =>
  apiClient(`/v1/integration/git/org/${getOrgId()}/projects/lite`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const getAllQualityProjectsRepos = (): Promise<any> =>
  apiClient(`/v1/integration/quality/org/${getOrgId()}/projects/lite`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const getAllJiraProjects = (): Promise<any> =>
  apiClient(`/v1/integration/jira/org/${getOrgId()}/projects/lite`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const getAllIssueEpic = (): Promise<any> =>
  apiClient(`/v1/issue/Epic/org/${getOrgId()}`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const getAllBoardNames = (): Promise<any> =>
  apiClient(`/v1/integration/jira/org/${getOrgId()}/board/lite`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const getAllIncidentManagement = (): Promise<any> =>
  apiClient(`/v1/integration/incident/org/${getOrgId()}/projects/lite`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const addOrUpdateTeam = (params: any): Promise<any> =>
  apiClient(`/v1/team`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params),
  });

export const updateTeam = (params: any): Promise<any> =>
  apiClient(`/v1/team/org/${getOrgId()}/team/${params.key.name}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(params),
  });

export const getTeamHomeData = (): Promise<any> =>
  apiClient(`/v2/account/org/${getOrgId()}/page/TeamSettings`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const getDoraSettings = (): Promise<any> =>
  apiClient(`/v1/dora/org/${getOrgId()}/settings`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const getAllPipelineProjects = (): Promise<any> =>
  apiClient(`/v1/integration/cicd/org/${getOrgId()}/projects/lite`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const getTestSuiteProjects = (): Promise<any> =>
  apiClient(`/v1/integration/test_suite/org/${getOrgId()}/projects/lite`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });
